const selectors = {
  drawer: ".cart-drawer",
  box: ".cart-drawer-box",
  activeClass: "cart-drawer--active",
  closeBtn: ".cart-drawer-header-close",
  qtyBtn: ".cart-drawer-quantity-selector button",
  removeBtn: ".cart-drawer-item-remove",
  upsellNav: ".cart-drawer-upsell-nav button",
  upsellContainer: ".cart-drawer-upsell-products",
  noteToggle: ".cart-drawer-note-toggle",
  noteContainer: ".cart-drawer-note",
  loadingClass: "cart-drawer--loading"
};

function openCartDrawer() {
  document.querySelector(selectors.drawer).classList.add(selectors.activeClass);
  document.body.style.overflow = "hidden";
}

function closeCartDrawer() {
  document.querySelector(selectors.drawer).classList.remove(selectors.activeClass);
  document.body.style.overflow = "";
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count, .cart-drawer-header-btn span, .site-header-cart--count").forEach((el) => {
    // If it's the header cart bubble, we ONLY update the data attribute and visibility
    // because the theme uses a :after pseudo-element to display the count.
    if (el.classList.contains('site-header-cart--count')) {
      el.setAttribute('data-header-cart-count', count > 0 ? count : "");
      if (count > 0) {
        el.classList.add('visible');
      } else {
        el.classList.remove('visible');
      }
      el.textContent = ""; // Clear text content to avoid double numbers
      return;
    }

    if (el.tagName === 'SPAN' && el.parentElement.classList.contains('cart-drawer-header-btn')) {
      el.textContent = `Cart (${count})`;
    } else {
      el.textContent = count;
    }
  });
}

async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const parser = new DOMParser();
  const html = parser.parseFromString(text, "text/html");
  const newBoxEl = html.querySelector(selectors.box);
  const currentBoxEl = document.querySelector(selectors.box);
  if (!newBoxEl || !currentBoxEl) {
    throw new Error("Cart drawer update failed: missing .cart-drawer-box in fetched or current DOM");
  }

  currentBoxEl.innerHTML = newBoxEl.innerHTML;
  addCartDrawerListeners();

  // Trigger theme re-initialization for things like Quick View
  document.dispatchEvent(new CustomEvent('theme:section:load', {
    detail: { sectionId: 'cart-drawer' },
    bubbles: true
  }));
}

// Quick Add to Cart by product handle with loader
// 1️⃣ Function: Quick Add with Loader
async function quickAddToCartByHandle(handle) {
  const drawer = document.querySelector(selectors.drawer);
  if (!drawer || drawer.dataset.cartDrawerQuickAdding === 'true') return;
  drawer.dataset.cartDrawerQuickAdding = 'true';
  drawer.classList.add(selectors.loadingClass); // show loader

  try {
    // Get product JSON
    const productRes = await fetch(`/products/${handle}.js`);
    const product = await productRes.json();

    // Get first available variant
    const variant = product.variants.find(v => v.available);
    if (!variant) return;

    // Add to cart
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: variant.id, quantity: 1 })
    });

    // Refresh cart
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();

    updateCartItemCounts(cart.item_count);
    await updateCartDrawer();
    openCartDrawer();

  } catch (err) {
    console.error('Quick add failed', err);
  } finally {
    drawer.classList.remove(selectors.loadingClass); // hide loader
    delete drawer.dataset.cartDrawerQuickAdding;
  }
}

// 2️⃣ Function: Add event listeners
function addCartDrawerListeners() {
  // Quantity Update
  document.querySelectorAll(selectors.qtyBtn).forEach((button) => {
    if (button.dataset.cartDrawerBound === 'true') return;
    button.dataset.cartDrawerBound = 'true';
    button.addEventListener("click", async () => {
      const rootItem = button.closest(".cart-drawer-item");
      const key = rootItem.getAttribute("data-line-item-key");
      const input = button.parentElement.querySelector("input");
      let currentQty = parseInt(input.value);
      const isPlus = button.classList.contains("cart-drawer-quantity-selector-plus");

      const newQty = isPlus ? currentQty + 1 : currentQty - 1;
      if (newQty < 0) return;

      await updateAjaxCart(key, newQty);
    });
  });

  // Remove Item
  document.querySelectorAll(selectors.removeBtn).forEach((button) => {
    if (button.dataset.cartDrawerBound === 'true') return;
    button.dataset.cartDrawerBound = 'true';
    button.addEventListener("click", async () => {
      const key = button.getAttribute("data-key");
      await updateAjaxCart(key, 0);
    });
  });

  // Upsell Navigation
  document.querySelectorAll(selectors.upsellNav).forEach(nav => {
    if (nav.dataset.cartDrawerBound === 'true') return;
    nav.dataset.cartDrawerBound = 'true';
    nav.addEventListener('click', () => {
      const container = document.querySelector(selectors.upsellContainer);
      const scrollAmount = 180;
      if (nav.classList.contains('upsell-prev')) {
        container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      } else {
        container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    });
  });

  // Quick Shop Add to Cart
  document.querySelectorAll('.upsell-quick-view').forEach(btn => {
    if (btn.dataset.cartDrawerBound === 'true') return;
    btn.dataset.cartDrawerBound = 'true';
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      const handle = btn.getAttribute('data-product-handle');
      if (!handle) return;
      quickAddToCartByHandle(handle); // ✅ now function exists
    });
  });

  // Note Toggle
  const toggle = document.querySelector(selectors.noteToggle);
  if (toggle) {
    toggle.addEventListener("click", () => {
      const container = document.querySelector(selectors.noteContainer);
      container.style.display = container.style.display === "none" ? "block" : "none";
    });
  }

  // Close Logic
  const closeBtn = document.querySelector(selectors.closeBtn);
  if (closeBtn && closeBtn.dataset.cartDrawerBound !== 'true') {
    closeBtn.dataset.cartDrawerBound = 'true';
    closeBtn.addEventListener("click", closeCartDrawer);
  }

  const drawerEl = document.querySelector(selectors.drawer);
  if (drawerEl && drawerEl.dataset.cartDrawerBound !== 'true') {
    drawerEl.dataset.cartDrawerBound = 'true';
    drawerEl.addEventListener("click", (e) => {
      if (e.target.classList.contains('cart-drawer')) closeCartDrawer();
    });
  }

  const boxEl = document.querySelector(selectors.box);
  if (boxEl && boxEl.dataset.cartDrawerBound !== 'true') {
    boxEl.dataset.cartDrawerBound = 'true';
    boxEl.addEventListener("click", (e) => e.stopPropagation());
  }
}

async function updateAjaxCart(key, qty) {
  const drawer = document.querySelector(selectors.drawer);
  drawer.classList.add(selectors.loadingClass);

  try {
    const res = await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ updates: { [key]: qty } }),
    });
    const cart = await res.json();
    updateCartItemCounts(cart.item_count);
    await updateCartDrawer();
  } catch (e) {
    console.error("Cart update failed", e);
  } finally {
    drawer.classList.remove(selectors.loadingClass);
  }
}

// Global Listeners
document.addEventListener("DOMContentLoaded", () => {
  addCartDrawerListeners();

  // Ajax Add to Cart Support
  document.addEventListener('submit', async (e) => {
    const target = e.target;
    const form = target instanceof HTMLFormElement ? target : target?.closest?.('form');
    if (!form) return;

    const action = form.getAttribute('action') || '';
    if (!action.includes('/cart/add')) return;

    // Guard against duplicate submit handlers / double clicks
    if (form.dataset.cartDrawerSubmitting === 'true') {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      return;
    }

    form.dataset.cartDrawerSubmitting = 'true';

    e.preventDefault();
    // Prevent other scripts from also handling the same submit and posting again
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
    const previousDisabled = submitButton ? submitButton.disabled : null;
    if (submitButton) submitButton.disabled = true;

    try {
      const formData = new FormData(form);

      await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      });

      const res = await fetch("/cart.js");
      const cart = await res.json();
      updateCartItemCounts(cart.item_count);
      await updateCartDrawer();
      openCartDrawer();
    } catch (err) {
      console.error('Ajax add to cart failed', err);
    } finally {
      if (submitButton && previousDisabled !== null) submitButton.disabled = previousDisabled;
      delete form.dataset.cartDrawerSubmitting;
    }
  }, true);

  // Header Cart Click (but not the "View Cart" button inside drawer)
  document.querySelectorAll('a[href="/cart"]').forEach((a) => {
    // Skip the "View Cart" button inside the cart drawer
    if (a.classList.contains('cart-drawer-view-cart')) return;
    
    a.addEventListener("click", (e) => {
      e.preventDefault();
      openCartDrawer();
    });
  });
});
